import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useCasinoPage } from "../CasinoPageContext";

interface FAQ {
  question: string;
  answer: string;
}

const FAQSection = () => {
  const { website } = useCasinoPage();
  const faqs: FAQ[] = website?.homepageContent?.faqSection.faqs || [];
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);

  return (
    <section
      id="faq-section"
      className="relative bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white py-20 md:py-24 overflow-hidden flex justify-center"
    >
      <div className="relative z-10 max-w-5xl w-full px-6 sm:px-8 lg:px-12 space-y-8">
        {/* Section Title */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight relative inline-block">
            <span className="relative z-10">FAQs</span>
            <span className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-cyan-500 rounded-full"></span>
          </h2>
          <p className="mt-4 text-gray-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Everything you need to know about CasinoB8 and online casino play,
            explained clearly and concisely.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="grid gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="group relative">
              {/* Gradient background hover */}
              <div className="absolute -inset-0.5  rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-300"></div>

              <div className="relative bg-slate-500/30 backdrop-blur-xl rounded-2xl overflow-hidden  transition-all">
                <button
                  onClick={() =>
                    setActiveAccordion(activeAccordion === index ? null : index)
                  }
                  className="w-full text-left p-6 md:p-7 flex items-start justify-between gap-4 hover:bg-cyan-500/5 transition-colors"
                >
                  <span className="text-lg md:text-xl font-bold text-white flex-1">
                    {faq.question}
                  </span>
                  <div
                    className={`mt-1 p-2 transition-all flex-shrink-0 ${
                      activeAccordion === index ? "rotate-90" : ""
                    }`}
                  >
                    <FaArrowRight className="text-cyan-400 w-4 h-4 md:w-5 md:h-5" />
                  </div>
                </button>

                {/* Accordion Content */}
                <div
                  className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
                    activeAccordion === index ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <div className="px-6 md:px-7 pb-6">
                    <div className="border-t border-cyan-500/20 pt-5">
                      <p className="text-gray-300 text-base md:text-lg leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
